<template>
  <div>
    <ValidationObserver ref="observer">
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="3" class="mr-8">
          <v-row>
            <v-col cols="12">
              <datepicker-cadu
                validateProviderRules="required"
                :menuOpen="menuOpen"
                :inputTitle="inputTitle"
                :inputValue="competencia"
                :propDate="competencia"
                :propMonths="allowedMonths"
                :disabled="isMonthEmpty || !edit"
                @value="(value) => selecionarData(value)"
                @selected="(data) => selecionarData(data)"
                ref="date"
              ></datepicker-cadu>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <v-row>
            <v-col cols="12">
              <validation-provider name="ultimaAtualizacao" mode="eager" v-slot="{ errors }">
                <input-cadu
                  :errorMessage="errors[0]"
                  title="Última Atualização"
                  v-model="ultimaAtualizacao"
                  icon="calendar"
                  v-mask="'##/##/####'"
                  :colorText="$vuetify.theme.themes.light.fontColor1"
                  disabled
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12" sm="12" md="3" class="mr-8">
          <v-row>
            <v-col cols="12" style="position: relative;">
              <validation-provider name="cooperadosAtivos" rules="required|max:7" mode="eager" v-slot="{ errors }">
                <input-cadu
                  title="Cooperados Ativos"
                  :errorMessage="errors[0]"
                  v-model="cooperadosAtivos"
                  :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                  :disabled="editProp"
                  onlyNumber
                  :colorText="'#00995d'"
                  textAlign="end"
                />
              </validation-provider>
              <div style="position: absolute; left: 94%; top: 10%;">
                <tooltip-help
                  width="400"
                  text="Médicos cooperados que exercem atividade médica, geram produção e possuem vínculo com a cooperativa."
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <v-row>
            <v-col cols="12" style="position: relative;">
              <validation-provider name="cooperadosInativos" rules="required|max:7" mode="eager" v-slot="{ errors }">
                <input-cadu
                  title="Cooperados Inativos"
                  :errorMessage="errors[0]"
                  v-model="cooperadosInativos"
                  :mask="['####', '#.###', '##.###', '###.###', '####.###', '#.###.###']"
                  :disabled="editProp"
                  onlyNumber
                  :colorText="'#00995d'"
                  textAlign="end"
                />
              </validation-provider>
              <div style="position: absolute; left: 94%; top: 10%;">
                <tooltip-help
                  width="400"
                  text="Médicos cooperados que possuem vínculo com a cooperativa, contudo, não exercem mais atividade médica."
                />
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters class="pt-4">
        <v-col cols="12" sm="12" md="3" class="mx-4">
          Total de Cooperados
        </v-col>
        <v-col cols="12" sm="12" md="3">
          <v-row no-gutters align="center" justify="start" style="height: 100%;">
            <v-col cols="12" sm="12" md="12">
              <input-cadu
                title=""
                :value="totalCooperados"
                :mask="[
                  '####',
                  '#.###',
                  '##.###',
                  '###.###',
                  '####.###',
                  '#.###.###',
                  '##.###.###',
                  '###.###.###',
                  '#.###.###.##'
                ]"
                :colorText="$vuetify.theme.themes.light.fontColor1"
                disabled
                textAlign="end"
                colorBgField="#333"
                colorInput="white"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
    <modal-cancelar v-model="showModalCancelar" @cancelar-edicao="cancelarEdicao()" />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mask } from 'vue-the-mask'
import Cooperado from '@/services/Perfil/Cooperado'
import { EventBus } from '../../../../../services/EventBus/EventBus'
import { cloneDeep, isEqual } from 'lodash'

export default {
  directives: {
    mask
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  props: {
    editProp: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      competencia: '',
      competenciaClone: '',
      ultimaAtualizacao: '',
      cooperadosAtivos: 0,
      cooperadosInativos: 0,
      // DatePicker
      menuOpen: false,
      inputTitle: 'Competência',
      allowedMonths: [],
      loading: false,
      tokenBearer: '',
      id: '',
      idAntigo: '',
      editavel: true,
      edit: JSON.parse(localStorage.getItem('optionEdit')),
      cloneCooperado: {},
      showModalCancelar: false
    }
  },
  async beforeMount() {
    this.tokenBearer = localStorage.getItem('tokenBearer')
    await this.getCooperado()

    EventBus.$on('carregarTableCooperado', (carregar) => {
      if (carregar) {
        this.getCooperados()
        EventBus.$emit('carregarTableCooperado', false)
      }
    })
  },
  methods: {
    async cancelarEdicao() {
      this.showModalCancelar = false
      await this.getCooperado()
    },
    async validarMudanca() {
      let newObj = {
        id: this.id,
        competencia: this.competencia,
        dataAtualizacao: this.ultimaAtualizacao,
        usuarioAtualizacao: {
          id: 5506,
          nome: 'Usuário Teste',
          unimed: {
            id: 2,
            codigo: 999,
            nomeFantasia: 'UNIMED BRASIL 2',
            textoExibicao: null
          }
        },
        editavel: this.editavel,
        qtCooperadosAtivos: this.cooperadosAtivos * 1,
        qtCooperadosInativos: this.cooperadosInativos * 1
      }

      newObj.usuarioAtualizacao = this.cloneCooperado.usuarioAtualizacao

      if (!isEqual(this.cloneCooperado, newObj)) {
        this.showModalCancelar = true
      }
    },
    async getCooperado() {
      this.getPendencias()
      this.getCooperados()
    },
    async getPendencias() {
      this.loading = true

      const cooperado = new Cooperado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await cooperado
        .getPendentesCooperados()
        .then((res) => (this.allowedMonths = res.data))
        .catch((err) => {
          this.$emit('error', err)
          console.error(err)
        })
        .finally(() => (this.loading = false))
    },
    async getCooperados() {
      this.loading = true

      const cooperado = new Cooperado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

      await cooperado
        .getUltimoCooperado()
        .then((res) => {
          const data = res.data

          if (data) {
            this.cloneCooperado = cloneDeep(data)
            this.competencia = data.competencia
            this.competenciaClone = data.competencia
            this.ultimaAtualizacao = data.dataAtualizacao
            this.cooperadosAtivos = data.qtCooperadosAtivos
            this.cooperadosInativos = data.qtCooperadosInativos
            this.id = data.id
            this.editavel = data.editavel

            this.$emit('editavel', data.editavel)
          } else {
            this.$emit('editavel', true)
          }
        })
        .catch((err) => {
          this.$emit('error', err)
          console.error(err)
        })
        .finally(() => (this.loading = false))
    },
    competenciaEquals(mesFormatado, mesSemFormatacao) {
      const arrMes = mesSemFormatacao.split('-')
      const mesComFormatacao = `${arrMes[1]}/${arrMes[0]}`
      return mesFormatado === mesComFormatacao
    },
    async putCooperado(justificativa) {
      if ((await this.$refs.observer.validate()) && (await this.$refs.date.validateInput())) {
        let result = this.allowedMonths[0] ? this.competenciaEquals(this.competencia, this.allowedMonths[0]) : true

        if (result || this.competencia === this.competenciaClone) {
          const cooperado = new Cooperado(this.tokenBearer, this.$appConfig.config.API, this.$idUnimed)

          const data = {
            competencia: this.competencia,
            id: this.id,
            qtCooperadosAtivos: this.cooperadosAtivos,
            qtCooperadosInativos: this.cooperadosInativos,
            justificativa
          }

          await cooperado
            .putCooperado(data)
            .then((res) => {
              const mensagem = res.data.mensagem
              const gerouPendencia = res.data.gerouPendencia
              if (gerouPendencia) {
                this.$emit('gerouPendencia', { mensagem, gerouPendencia })
              } else {
                this.id = res.data.idCompetencia
                this.$emit('success', {
                  origin: 'cooperados',
                  message: 'Quantidade de cooperados atualizada com sucesso!'
                });
              }
            })
            .catch((err) => {

              debugger;

              this.$emit('error', err)
              this.getCooperados()
            });
        } else {
          this.$emit('pendente', this.allowedMonths[0])
        }
      }
    },
    clean() {
      this.cooperadosAtivos = 0
      this.cooperadosInativos = 0
    },
    selecionarData(data) {
      if (data.length === 7 && data !== this.competencia) {
        this.editavel = true
        this.$emit('editavel', this.editavel)
        this.competencia = data
        this.clean()
      }
    }
  },
  computed: {
    totalCooperados() {
      let ativo = Number(this.cooperadosAtivos) || 0
      let inativo = Number(this.cooperadosInativos) || 0
      let result = ativo + inativo
      return result || 0
    },
    isMonthEmpty() {
      return this.allowedMonths.length === 0
    }
  },
  watch: {
    loading() {
      this.$emit('input', this.loading)
    }
  }
}
</script>

<style scoped></style>
